import { render, staticRenderFns } from "./ModalRequestDemo.vue?vue&type=template&id=1b42a99f"
import script from "./ModalRequestDemo.vue?vue&type=script&lang=ts"
export * from "./ModalRequestDemo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports